import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './index.css';

const propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  thirdPartyOptions: PropTypes.object,
};

const defaultProps = {
  options: [],
  value: '',
  thirdPartyOptions: {},
};

const SearchDropdown = props => {
  const { name, value, options, onChange, thirdPartyOptions } = props;

  return (
    <Select
      {...thirdPartyOptions}
      name={name}
      value={value}
      options={options}
      onChange={onChange}
    />
  );
};

SearchDropdown.propTypes = propTypes;
SearchDropdown.defaultProps = defaultProps;

export default SearchDropdown;



// WEBPACK FOOTER //
// ../ui-components/components/SearchDropdown/index.jsx